export default __webpack_public_path__ + "i18n/translations/translation.686133d0.json";